import type { EventWithContext } from '@epasu/core';
import { CalendarDays } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { formatDateTime } from '@/lib/utils';

interface Props {
  events: EventWithContext[];
}

/** Am Projekt hängende Termine — rein lesend, wie im Kalender selbst verknüpft. */
export function EventsCard({ events }: Props) {
  return (
    <Card className="p-4">
      <h2 className="flex items-center gap-2 text-sm font-semibold">
        <CalendarDays className="h-4 w-4 text-muted-foreground" />
        Termine
      </h2>

      {events.length === 0 ? (
        <p className="mt-2 text-sm text-muted-foreground">Noch kein Termin verknüpft.</p>
      ) : (
        <ul className="mt-3 space-y-2">
          {events.map((e) => (
            <li key={e.id} className="text-sm">
              <span className="block font-medium">{e.title ?? 'Termin'}</span>
              <span className="block text-xs text-muted-foreground">
                {formatDateTime(e.startAt)}
              </span>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}
